import { getCompaniesColumns, getCompaniesData } from '~/components/GroupInformationPage/GroupInformationPage.utils';
import { formatDateString, getDateSortValue } from '~/utils/dates';

export function getCompaniesTrashData(data = [], countriesByName, userInfo) {
  const companiesById = data.reduce((acc, company) => {
    acc[company.id] = company;
    return acc;
  }, {});

  return getCompaniesData(data, countriesByName).map((item) => {
    const company = companiesById[item.id] || {};

    return {
      ...item,
      deletedAt: formatDateString(company.deletedAt, userInfo.dateFormat) || 'n/a',
      deletedAtSort: getDateSortValue(company.deletedAt),
    };
  });
}

export function getCompaniesTrashColumns() {
  return [...getCompaniesColumns(), { label: 'Deleted', sortBy: 'deletedAtSort', value: 'deletedAt' }];
}
